// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

// webgen:import { "defaultName": "Enums", "path": "../Enums" }
// webgen:import { "names": ["Currency", "NewCurrency"], "path": "../Currency/Currency" }
// webgen:import { "names": ["CurrencyString"], "path": "../../../utils/currency" }
// webgen:import { "names": ["TenantDefaultMargins"], "path": "../../tenantDefaultMargins" }

import type { PartialDeep } from 'type-fest';

import { CurrencyString } from '../../../utils/currency';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { TenantDefaultMargins } from '../../tenantDefaultMargins';
import { Cost, type CostWireFormat, NewCost } from '../Cost/Cost';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class ReadyMixConstants {
  readonly operatingCost: Cost;
  readonly sgaCost: Cost;
  readonly targetMarginPercentageOverride: string | null;
  readonly minimumMarginPercentageOverride: string | null;
  readonly targetMarginFlatAmountOverride: Currency | null;
  readonly minimumMarginFlatAmountOverride: Currency | null;

  constructor(data: { [key: string]: any } = {}) {
    this.operatingCost = NewCost(data.operatingCost);
    this.sgaCost = NewCost(data.sgaCost);
    this.targetMarginPercentageOverride =
      data.targetMarginPercentageOverride === undefined
        ? null
        : data.targetMarginPercentageOverride;
    this.minimumMarginPercentageOverride =
      data.minimumMarginPercentageOverride === undefined
        ? null
        : data.minimumMarginPercentageOverride;
    this.targetMarginFlatAmountOverride =
      (data.targetMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.targetMarginFlatAmountOverride);
    this.minimumMarginFlatAmountOverride =
      (data.minimumMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.minimumMarginFlatAmountOverride);
  }

  static zero(): ReadyMixConstants {
    const zeroValues: ExcludeMethodsDeep<ReadyMixConstants> = {
      operatingCost: Cost.zero(),
      sgaCost: Cost.zero(),
      targetMarginPercentageOverride: null,
      minimumMarginPercentageOverride: null,
      targetMarginFlatAmountOverride: null,
      minimumMarginFlatAmountOverride: null,
    };
    return new ReadyMixConstants(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  //---------------//
  // Target Margin //
  //---------------//

  targetMarginFlatAmount(defaultValue: string): Currency {
    return (
      this.targetMarginFlatAmountOverride ?? NewCurrency({ number: defaultValue, currency: 'USD' })
    );
  }

  targetMarginPercentage(defaultValue: string): number {
    return parseFloat(this.targetMarginPercentageOverride ?? defaultValue) * 100;
  }

  targetMarginFlatAmountDisplay(defaultValue: string): string {
    return CurrencyString({ cur: this.targetMarginFlatAmount(defaultValue) });
  }

  targetMarginPercentageDisplay(defaultValue: string): string {
    return `${String(this.targetMarginPercentage(defaultValue))}%`;
  }

  targetMargin(
    marginConfiguration: Enums.MarginConfiguration,
    defaultMargins: TenantDefaultMargins,
  ): string {
    return marginConfiguration === Enums.MarginConfiguration.Percentage
      ? String(this.targetMarginPercentage(defaultMargins.targetMarginPercentage))
      : this.targetMarginFlatAmount(defaultMargins.targetMarginFlatAmount).number;
  }

  targetMarginDisplay(
    marginConfiguration: Enums.MarginConfiguration,
    defaultMargins: TenantDefaultMargins,
  ): string {
    return marginConfiguration === Enums.MarginConfiguration.Percentage
      ? this.targetMarginPercentageDisplay(defaultMargins.targetMarginPercentage)
      : this.targetMarginFlatAmountDisplay(defaultMargins.targetMarginFlatAmount);
  }

  //----------------//
  // Minimum Margin //
  //----------------//

  minimumMarginFlatAmount(defaultValue: string): Currency {
    return (
      this.minimumMarginFlatAmountOverride ?? NewCurrency({ number: defaultValue, currency: 'USD' })
    );
  }

  minimumMarginFlatAmountDisplay(defaultValue: string): string {
    return CurrencyString({ cur: this.minimumMarginFlatAmount(defaultValue) });
  }
  minimumMarginPercentage(defaultValue: string): number {
    return parseFloat(
      (parseFloat(this.minimumMarginPercentageOverride ?? defaultValue) * 100).toFixed(3),
    );
  }

  minimumMarginPercentageDisplay(defaultValue: string): string {
    return `${String(this.minimumMarginPercentage(defaultValue))}%`;
  }

  minimumMarginDisplay(
    marginConfiguration: Enums.MarginConfiguration,
    defaultMargins: TenantDefaultMargins,
  ): string {
    return marginConfiguration === Enums.MarginConfiguration.Percentage
      ? this.minimumMarginPercentageDisplay(defaultMargins.minimumMarginPercentage)
      : this.minimumMarginFlatAmountDisplay(defaultMargins.minimumMarginFlatAmount);
  }

  minimumMargin(
    marginConfiguration: Enums.MarginConfiguration,
    defaultMargins: TenantDefaultMargins,
  ): string {
    return marginConfiguration === Enums.MarginConfiguration.Percentage
      ? String(this.minimumMarginPercentage(defaultMargins.minimumMarginPercentage))
      : this.minimumMarginFlatAmount(defaultMargins.minimumMarginFlatAmount).number;
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReadyMixConstantsWireFormat = {
  operatingCost: CostWireFormat;
  sgaCost: CostWireFormat;
  targetMarginPercentageOverride: string | null;
  minimumMarginPercentageOverride: string | null;
  targetMarginFlatAmountOverride: CurrencyWireFormat | null;
  minimumMarginFlatAmountOverride: CurrencyWireFormat | null;
};

type NewReadyMixConstantsProps = PartialDeep<ReadyMixConstants, { recurseIntoArrays: true }>;
export const NewReadyMixConstants: (props: NewReadyMixConstantsProps) => ReadyMixConstants = (
  props,
) => new ReadyMixConstants(props);

type NewReadyMixConstantsFromWireFormatProps = PartialDeep<
  ReadyMixConstantsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReadyMixConstantsFromWireFormat: (
  props: NewReadyMixConstantsFromWireFormatProps,
) => ReadyMixConstants = (props) => new ReadyMixConstants(props);
